.columnBackground {
  height: 100%;
  background-image: url("~images/empty-time-button.png");
  background-repeat: repeat;
  background-position: center top;
}

.column {
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 20px;
  width: 100%;
  align-self: start;
  align-items: start;
  justify-self: center;
  justify-items: center;
}

.slotArea {
  grid-area: slots;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  margin: 14px 0;
}
